// import React, { useState, useCallback, useEffect, useMemo } from "react";
// import { Loader2, Users, ChevronDown } from "lucide-react";
// import Cookies from "js-cookie";
// import api from "../chat/api";
// import { toast } from "react-toastify";
// import Checkbox from "../../Checkbox";
// import InviteTeamMemberModal from "./InviteTeamMemberModal";
// import MemberActionMenu from "./MemberActionMenu";
import ReassignProjectsModal from "./ReassignProjectsModal";

// const MembersPage = ({ 
//   teamMembers, 
//   loading, 
//   searchQuery, 
//   isInviteModalOpen, 
//   setIsInviteModalOpen, 
//   organizationId,
//   onRefresh,
//   selectedMembers,
//   setSelectedMembers 
// }) => {
//   const [selectAll, setSelectAll] = useState(false);

//   const filteredTeamMembers = useMemo(() => {
//     if (!searchQuery.trim()) {
//       return teamMembers;
//     }
//     const query = searchQuery.toLowerCase().trim();
//     return teamMembers.filter(member => 
//       member.name.toLowerCase().includes(query) ||
//       member.email.toLowerCase().includes(query) ||
//       member.role.toLowerCase().includes(query)
//     );
//   }, [teamMembers, searchQuery]);

//   const allSelected = selectedMembers.length === filteredTeamMembers.length && filteredTeamMembers.length > 0;

//   useEffect(() => {
//     setSelectAll(allSelected);
//   }, [selectedMembers.length, allSelected]);

//   const handleSelectAllChange = useCallback((checked) => {
//     if (checked) {
//       const selectableIds = filteredTeamMembers
//         .filter(member => member.role !== "admin")
//         .map(member => member.id);
//       setSelectedMembers(selectableIds);
//       setSelectAll(true);
//     } else {
//       setSelectedMembers([]);
//       setSelectAll(false);
//     }
//   }, [filteredTeamMembers, setSelectedMembers]);

//   const handleMemberSelect = useCallback((checked, memberId) => {
//     if (checked) {
//       setSelectedMembers(prev => [...prev, memberId]);
//     } else {
//       setSelectedMembers(prev => prev.filter(id => id !== memberId));
//     }
//   }, [setSelectedMembers]);

//   const handleInviteSuccess = useCallback(() => {
//     if (onRefresh) {
//       onRefresh();
//     }
//   }, [onRefresh]);

//   const handleRemoveAccess = useCallback(async (member) => {
//     const token = Cookies.get("access_token");
//     if (!token) {
//       toast.error("No authentication token available");
//       throw new Error("No token");
//     }

//     if (!member.orgId) {
//       toast.error("Organization ID not found");
//       throw new Error("No org ID");
//     }

//     try {
//       const requestBody = {
//         organization_id: member.orgId,
//         user_ids: [member.user_id]
//       };

//       const response = await api.post("/api/v1/org/members/remove/", requestBody);

//       if (response.status === 200 || response.status === 201) {
//         toast.success(`${member.name} has been removed successfully!`);
//         setTimeout(() => {
//           if (onRefresh) {
//             onRefresh();
//           }
//         }, 2000);
//       }
//     } catch (error) {
//       console.error("Error removing member:", error);
//       toast.error(error.response?.data?.message || "Failed to remove member.");
//       throw error;
//     }
//   }, [onRefresh]);

//   return (
//     // Changed: Using absolute inset-0 to perfectly fill the parent container created in MyTeam.jsx
//     <div className="absolute inset-0 overflow-y-auto overflow-x-hidden custom-scrollbar bg-white">
//       {loading ? (
//         <div className="h-full w-full flex items-center justify-center">
//           <div className="flex flex-col items-center gap-3">
//             <Loader2 className="w-10 h-10 text-[#C95EBE] animate-spin" />
//             <p className="text-sm text-gray-500">Loading team members...</p>
//           </div>
//         </div>
//       ) : filteredTeamMembers.length === 0 ? (
//         <div className="h-full w-full flex items-center justify-center">
//           <div className="text-center">
//             <Users className="w-12 h-12 text-gray-300 mx-auto mb-3" />
//             <p className="text-sm text-gray-500">
//               {searchQuery ? "No team members match your search" : "No team members found"}
//             </p>
//           </div>
//         </div>
//       ) : (
//         <table className="w-full text-left border-collapse table-fixed">
//           <thead>
//             <tr className="border-b border-black/10 sticky top-0 z-20 bg-gray-50">
//               <th className="px-4 py-3 w-12 bg-gray-50">
//                 <Checkbox
//                   id="select-all"
//                   checked={selectAll}
//                   onChange={handleSelectAllChange}
//                   size="sm"
//                 />
//               </th>
//               {/* Changed: Removed min-w from headers to allow fluid shrinking */}
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-2/5">Name</th>
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[15%]">Role</th>
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%]">Date Joined</th>
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%]">Last Login</th>
//               <th className="px-4 py-3 w-12 bg-gray-50"></th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-gray-100">
//             {filteredTeamMembers.map((member) => (
//               <tr key={member.id} className="bg-white hover:bg-gray-50 transition-colors group">
//               <td className="px-4 py-3 w-12 border-b border-gray-100">
//                 <Checkbox
//                   id={`member-${member.id}`}
//                   name={`member-${member.id}`}
//                   checked={selectedMembers.includes(member.id)}
//                   onChange={(checked) => handleMemberSelect(checked, member.id)}
//                   size="sm"
//                   disabled={member.role === "admin"}
//                 />
//               </td>
            
//               <td className="px-4 py-3 truncate border-b border-gray-100">
//                 <div className="flex items-center gap-3">
//                   <div className="w-9 h-9 rounded-full bg-[#F200D80D] text-[#C95EBE] flex items-center justify-center  font-semibold text-[14px] flex-shrink-0">
//                     {member.initials}
//                   </div>
//                   <div className="min-w-0 flex-1">
//                     <div className="text-[14px] font-medium text-[#18101C] truncate">{member.name}</div>
//                     <div className="text-[13px] text-gray-500 truncate">{member.email}</div>
//                   </div>
//                 </div>
//               </td>
            
//               <td className="px-4 py-3 border-b border-gray-100">
//                 {member.isOwner ? (
//                   <span className="inline-block px-3 py-1 bg-purple-50 text-[#C95EBE] text-xs font-medium rounded-md">
//                     Owner
//                   </span>
//                 ) : (
//                   <div className="relative inline-block">
//                     <button className="flex items-center justify-between gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-md text-[13px] text-gray-700 w-[100px] capitalize group-hover:bg-gray-50 transition-colors">
//                       {member.role}
//                       <ChevronDown size={14} className="text-gray-400" />
//                     </button>
//                   </div>
//                 )}
//               </td>
            
//               <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100">
//                 {member.dateJoined}
//               </td>
            
//               <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100">
//                 {member.lastLogin}
//               </td>
            
//               <td className="px-4 py-3 w-12 text-right border-b border-gray-100">
//                 {!member.isOwner && (
//                   <MemberActionMenu 
//                     member={member}
//                     onRemoveAccess={handleRemoveAccess}
//                   />
//                 )}
//               </td>
//             </tr>
            
//             ))}
//           </tbody>
//         </table>
//       )}

//       <InviteTeamMemberModal 
//         isOpen={isInviteModalOpen}
//         onClose={() => setIsInviteModalOpen(false)}
//         onInviteSuccess={handleInviteSuccess}
//       />
//     </div>
//   );
// };

// export default MembersPage;


import React, { useCallback, useMemo, useState } from "react";
import { Loader2, Users, ChevronDown } from "lucide-react";
import Cookies from "js-cookie";
import api from "../chat/api";
import toast from "react-hot-toast";
import Checkbox from "../../Checkbox";
import InviteTeamMemberModal from "./InviteTeamMemberModal";
import MemberActionMenu from "./MemberActionMenu";
import RemoveMemberModal from "./RemoveMemberModal";
import { groupByOrg, strandedMessage, summarizeRemoval } from "./bulkRemoval";

const MembersPage = ({
  teamMembers,
  loading,
  searchQuery,
  isInviteModalOpen,
  setIsInviteModalOpen,
  organizationId,
  onRefresh,
  selectedMembers,
  setSelectedMembers,
  isAdmin = false,
  // True while the toolbar's bulk removal is running, so the row menus don't
  // start a second, overlapping removal of the same people.
  bulkRemovalActive = false,
  // user_id -> projects owned, prefetched by MyTeam for the whole roster. Lets
  // the click pick a dialog with no round-trip; null means fall back to asking.
  ownedCounts = null,
}) => {
  const filteredTeamMembers = useMemo(() => {
    if (!searchQuery.trim()) {
      return teamMembers;
    }

    const query = searchQuery.toLowerCase().trim();

    return teamMembers.filter(
      (member) =>
        member.name.toLowerCase().includes(query) ||
        member.email.toLowerCase().includes(query) ||
        member.role.toLowerCase().includes(query)
    );
  }, [teamMembers, searchQuery]);

  const selectableMemberIds = useMemo(() => {
    return filteredTeamMembers
      .filter((member) => member.role !== "admin")
      .map((member) => member.id);
  }, [filteredTeamMembers]);

  const selectAll = useMemo(() => {
    return (
      selectableMemberIds.length > 0 &&
      selectableMemberIds.every((id) => selectedMembers.includes(id))
    );
  }, [selectableMemberIds, selectedMembers]);

  const handleSelectAllChange = useCallback(
    (checked) => {
      if (checked) {
        setSelectedMembers((prev) => {
          const merged = new Set([...prev, ...selectableMemberIds]);
          return Array.from(merged);
        });
      } else {
        setSelectedMembers((prev) =>
          prev.filter((id) => !selectableMemberIds.includes(id))
        );
      }
    },
    [selectableMemberIds, setSelectedMembers]
  );

  const handleMemberSelect = useCallback(
    (checked, memberId) => {
      if (checked) {
        setSelectedMembers((prev) =>
          prev.includes(memberId) ? prev : [...prev, memberId]
        );
      } else {
        setSelectedMembers((prev) => prev.filter((id) => id !== memberId));
      }
    },
    [setSelectedMembers]
  );

  const handleInviteSuccess = useCallback(() => {
    if (onRefresh) {
      onRefresh();
    }
  }, [onRefresh]);

  // ── Reassigning a leaver's projects ────────────────────────────────────────
  // Rename / archive / delete / share are owner-only, so removing someone who
  // owns projects leaves them stuck. If they own any, we ask who takes over
  // before the removal goes through; if they own none, nothing changes.
  const [reassignFor, setReassignFor] = useState(null);
  const [reassignRemoving, setReassignRemoving] = useState(false);
  // Exactly one dialog goes up per removal: the plain confirm when they own
  // nothing, the reassignment modal when they own something. Which one is
  // decided here, after asking the server, rather than in the row menu.
  const [confirmFor, setConfirmFor] = useState(null);
  const [confirmUnknown, setConfirmUnknown] = useState(false);
  // The ownership lookup happens between the click and the dialog, so the menus
  // stay shut during it — otherwise an impatient second click raises a second
  // dialog for the same person.
  const [preparing, setPreparing] = useState(false);

  // The endpoint answers 200 even when it refuses the member — the truth is in
  // removed_user_ids / errors, so the outcome is read out of the body rather
  // than inferred from the status code.
  const doRemoveMember = useCallback(
    async (member, reassignments) => {
      const groups = groupByOrg([member]);
      const settled = await Promise.allSettled([
        api.post("/api/v1/org/members/remove/", {
          organization_id: member.orgId,
          user_ids: [member.user_id],
          ...(reassignments && Object.keys(reassignments).length
            ? { reassignments }
            : {}),
        }),
      ]);
      const outcome = summarizeRemoval(groups, settled);

      if (outcome.removed === 0) {
        throw new Error(outcome.error || `Couldn't remove ${member.name}.`);
      }

      toast.success(
        outcome.reassigned
          ? `${member.name} removed. ${outcome.reassigned} project(s) reassigned.`
          : `${member.name} has been removed successfully!`
      );

      const stranded = strandedMessage(outcome);
      if (stranded) toast.error(stranded);

      if (onRefresh) onRefresh();
      return outcome;
    },
    [onRefresh]
  );

  const handleRemoveAccess = useCallback(async (member) => {
    const token = Cookies.get("access_token");
    if (!token) {
      toast.error("No authentication token available");
      return;
    }

    if (!member.orgId) {
      toast.error("Organization ID not found");
      return;
    }

    // What they own decides which dialog appears, so it has to be known before
    // one can open. The prefetched counts make that free; only fall back to
    // asking (and stalling) when they aren't there.
    const cached = ownedCounts?.[String(member.user_id)];
    if (cached !== undefined) {
      if (cached > 0) setReassignFor(member);
      else {
        setConfirmUnknown(false);
        setConfirmFor(member);
      }
      return;
    }

    setPreparing(true);
    let ownedCount = 0;
    let unknown = false;
    try {
      const res = await api.get(
        `/api/v1/org/members/owned-projects/?organization_id=${encodeURIComponent(
          member.orgId
        )}&user_ids=${encodeURIComponent(member.user_id)}`
      );
      ownedCount = (res.data?.projects || []).length;
    } catch {
      unknown = true; // never block a removal because this lookup failed
    }
    setPreparing(false);

    if (ownedCount > 0) {
      setReassignFor(member);
      return;
    }

    setConfirmUnknown(unknown);
    setConfirmFor(member);
  }, [ownedCounts]);

  const closeConfirm = useCallback(() => {
    setConfirmFor(null);
    setConfirmUnknown(false);
  }, []);

  return (
    <div className="absolute inset-0 overflow-y-auto overflow-x-hidden custom-scrollbar bg-white">
      {loading ? (
        <div className="h-full w-full flex items-center justify-center">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="w-10 h-10 text-[#C95EBE] animate-spin" />
            <p className="text-sm text-gray-500">Loading team members...</p>
          </div>
        </div>
      ) : filteredTeamMembers.length === 0 ? (
        <div className="h-full w-full flex items-center justify-center">
          <div className="text-center">
            <Users className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-sm text-gray-500">
              {searchQuery
                ? "No team members match your search"
                : "No team members found"}
            </p>
          </div>
        </div>
      ) : (
        <table className="w-full text-left border-collapse table-fixed border-none border-l-0 border-r-0">
          <thead>
            <tr className="border-b border-black/10 border-l-0 border-r-0 border-t-0 sticky top-0 z-20 bg-gray-50">
              {isAdmin && (
                <th className="px-4 py-3 w-12 bg-gray-50 border-none border-l-0 border-r-0">
                  <Checkbox
                    id="select-all"
                    checked={selectAll}
                    onChange={handleSelectAllChange}
                    size="sm"
                    disabled={selectableMemberIds.length === 0}
                  />
                </th>
              )}
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[35%] border-none border-l-0 border-r-0">
                Name
              </th>
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[15%] border-none border-l-0 border-r-0">
                Role
              </th>
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%] border-none border-l-0 border-r-0">
                Date Joined
              </th>
              {isAdmin && (
                <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%] border-none border-l-0 border-r-0">
                  Last Login
                </th>
              )}
              {isAdmin && (
                <th className="px-4 py-3 w-12 bg-gray-50 border-none border-l-0 border-r-0"></th>
              )}
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 border-l-0 border-r-0 border-none">
            {filteredTeamMembers.map((member) => (
              <tr
                key={member.id}
                className="bg-white hover:bg-gray-50 transition-colors group border-l-0 border-r-0 border-t-0 border-b border-gray-100"
              >
                {isAdmin && (
                  <td className="px-4 py-3 w-12 border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                    <Checkbox
                      id={`member-${member.id}`}
                      name={`member-${member.id}`}
                      checked={selectedMembers.includes(member.id)}
                      onChange={(checked) =>
                        handleMemberSelect(checked, member.id)
                      }
                      size="sm"
                      disabled={member.role === "admin"}
                    />
                  </td>
                )}

                <td className="px-4 py-3 truncate border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-[#F200D80D] text-[#C95EBE] flex items-center justify-center font-semibold text-[14px] flex-shrink-0">
                      {member.initials}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="text-[14px] font-medium text-[#18101C] truncate">
                        {member.name}
                      </div>
                      <div className="text-[13px] text-gray-500 truncate">
                        {member.email}
                      </div>
                    </div>
                  </div>
                </td>

                <td className="px-2 py-3 border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  {member.isOwner ? (
                    <span className="inline-block px-3 py-1 bg-purple-50 text-[#C95EBE] text-xs font-medium rounded-md">
                      Owner
                    </span>
                  ) : (
                    <div className="relative inline-block">
                      <button className="flex items-center justify-between gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-md text-[13px] text-gray-700 w-[100px] capitalize group-hover:bg-gray-50 transition-colors">
                        {member.role}
                        <ChevronDown size={14} className="text-gray-400" />
                      </button>
                    </div>
                  )}
                </td>

                <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  {member.dateJoined}
                </td>

                {isAdmin && (
                  <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                    {member.lastLogin}
                  </td>
                )}

                {isAdmin && (
                  <td className="px-4 py-3 w-12 text-right border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                    {!member.isOwner && (
                      <MemberActionMenu
                        member={member}
                        onRemoveAccess={handleRemoveAccess}
                        locked={bulkRemovalActive || preparing || !!confirmFor || !!reassignFor}
                      />
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <ReassignProjectsModal
        isOpen={!!reassignFor}
        organizationId={reassignFor?.orgId}
        departingMembers={reassignFor ? [reassignFor] : []}
        candidates={(teamMembers || [])
          .filter((m) => m.isActive !== false && m.user_id !== reassignFor?.user_id)
          .map((m) => ({ user_id: m.user_id, full_name: m.name, email: m.email }))}
        removing={reassignRemoving}
        onClose={() => {
          if (reassignRemoving) return;
          setReassignFor(null);
        }}
        onConfirm={async (assignments) => {
          const cleaned = Object.fromEntries(
            Object.entries(assignments || {}).filter(([, v]) => v)
          );
          setReassignRemoving(true);
          try {
            await doRemoveMember(reassignFor, cleaned);
            setReassignFor(null);
          } catch (e) {
            toast.error(e.message || "Failed to remove member.");
          } finally {
            setReassignRemoving(false);
          }
        }}
      />

      <RemoveMemberModal
        isOpen={!!confirmFor}
        members={confirmFor ? [confirmFor] : []}
        ownershipUnknown={confirmUnknown}
        onClose={closeConfirm}
        onConfirm={async () => {
          try {
            await doRemoveMember(confirmFor);
          } catch (e) {
            toast.error(e.message || "Failed to remove member.");
            throw e;
          }
        }}
      />

      <InviteTeamMemberModal
        isOpen={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
        onInviteSuccess={handleInviteSuccess}
      />
    </div>
  );
};

export default MembersPage;